/* eslint-env browser */
function pagination() {
    const loadContainerEl = document.querySelector('[gh-post-load-container]');
    if (!loadContainerEl) {
        return;
    }
    const buttonElement = document.querySelector('[gh-load-more]');
    if (!buttonElement) {
        return;
    }

    const hasNextPage = document.querySelector('link[rel=next]');
    if (!hasNextPage) {
        buttonElement.remove();
        return;
    }

    const postElWidth = loadContainerEl.querySelector('[gh-post-load-container]> *').offsetWidth;
    let loading = false;
    const loadNextPage = async function () {
        if (loading) {
            return;
        }

        const nextElement = document.querySelector('link[rel=next]');
        if (!nextElement) {
            // 加两个占位
            for (let i = 0; i < 2; i++) {
                const seatNode = document.createElement('div');
                seatNode.style.width = postElWidth + 'px';
                loadContainerEl.appendChild(seatNode);
            }
            return;
        }

        try {
            loading = true;
            const res = await fetch(nextElement.href);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const postElements = doc.querySelectorAll('[gh-post-load-container]> *');
            const fragment = document.createDocumentFragment();
            postElements.forEach(function (post) {
                const clonedItem = document.importNode(post, true);
                fragment.appendChild(clonedItem);
            });
            loadContainerEl.appendChild(fragment);
            const resNextElement = doc.querySelector('link[rel=next]');
            if (resNextElement && resNextElement.href) {
                nextElement.href = resNextElement.href;
            } else {
                nextElement.remove();
                if (buttonElement) {
                    buttonElement.remove();
                }
                // 加两个占位
                for (let i = 0; i < 2; i++) {
                    const seatNode = document.createElement('div');
                    seatNode.style.width = postElWidth + 'px';
                    loadContainerEl.appendChild(seatNode);
                }
            }
        } catch (e) {
            nextElement.remove();
            if (buttonElement) {
                buttonElement.remove();
            }
            throw e;
        }
        loading = false;
    };

    buttonElement.addEventListener('click', loadNextPage);
}

pagination();
